<template>
  <div class="p-option-howto">
    <h2 class="c-title">
      <div class="c-title__text">ご利用までの流れ</div>
    </h2>
    <ul class="p-option-howto-list">
      <li class="p-option-howto-list__item">
        <div class="p-option-howto__title">STEP.1</div>
        <h3 class="c-title">
          <div class="c-title__text u-fs24">お問い合わせ</div>
        </h3>
        <div class="c-text">
          ご検討中のお客様は、下記のフお問い合わせボタンよりお願いいたします。担当者から折り返しご連絡致します。
        </div>
      </li>
      <li class="p-option-howto-list__item">
        <div class="p-option-howto__title">STEP.2</div>
        <h3 class="c-title">
          <div class="c-title__text u-fs24">申し込み</div>
        </h3>
        <div class="c-text">
          申し込みに関する補足説明のテキストが入ります補足説明のテキストが入ります補足説明のテキストが入ります
        </div>
      </li>
      <li class="p-option-howto-list__item">
        <div class="p-option-howto__title">STEP.3</div>
        <h3 class="c-title">
          <div class="c-title__text u-fs24">ご利用開始</div>
        </h3>
        <div class="c-text">
          ご利用開始に関する補足説明のテキストが入ります補足説明のテキストが入ります補足説明のテキストが入ります
        </div>
      </li>
    </ul>
  </div>
</template>
